import { Link } from 'react-router-dom';
import { useAlbumNavigation } from '@/hooks/useAlbumNavigation';
import { cn } from '@/lib/utils';

type ClickableUserDisplayProps = {
  userId?: string | null;
  displayName: string;
  avatarUrl?: string | null;
  showAvatar?: boolean;
  variant?: 'compact' | 'regular';
  className?: string;
  avatarClassName?: string;
  nameClassName?: string;
  onNavigate?: () => void;
};

const getInitial = (name: string) => (name?.trim()?.charAt(0) || 'U').toUpperCase();

const ClickableUserDisplay = ({
  userId,
  displayName,
  avatarUrl,
  showAvatar = true,
  variant = 'regular',
  className,
  avatarClassName,
  nameClassName,
  onNavigate,
}: ClickableUserDisplayProps) => {
  const { getAlbumPath } = useAlbumNavigation();
  const avatarSizeClass = variant === 'compact' ? 'w-8 h-8' : 'w-10 h-10';
  const textSizeClass = variant === 'compact' ? 'text-sm' : 'text-base';
  const containerClass = cn('inline-flex items-center gap-2 min-w-0', className);

  const content = (
    <>
      {showAvatar &&
        (avatarUrl ? (
          <img
            src={avatarUrl}
            alt={displayName}
            className={cn(avatarSizeClass, 'rounded-full object-cover flex-shrink-0 border', avatarClassName)}
          />
        ) : (
          <div
            className={cn(
              avatarSizeClass,
              'rounded-full bg-muted flex items-center justify-center font-semibold flex-shrink-0',
              avatarClassName
            )}
          >
            {getInitial(displayName)}
          </div>
        ))}
      <span className={cn('font-medium truncate', textSizeClass, nameClassName)}>{displayName}</span>
    </>
  );

  if (!userId) {
    return <div className={containerClass}>{content}</div>;
  }

  return (
    <Link
      to={getAlbumPath(`/usuario?userId=${userId}`)}
      className={cn(containerClass, 'hover:opacity-90 transition-opacity')}
      onClick={onNavigate}
    >
      {content}
    </Link>
  );
};

export default ClickableUserDisplay;
